
import {devices, sizes, isBeforeOrEqualDevice} from './config';
let $el = $(".Section__banner");

export function adaptCards(){
    $('.Projects__articles').each((i, el) => {
        let headerMaxSize = 0,
            bodyMaxSize = 0,
            $cards = $(el).find('.ArticleCard');

        $cards.find('.ArticleCard__header').css({height: 'auto'});
        $cards.find('.ArticleCard__body').css({height: 'auto'});

        if (!isBeforeOrEqualDevice(devices.SM)) {
            $cards.each((index, card) => {
                let $header = $(card).find('.ArticleCard__header'),
                    $body = $(card).find('.ArticleCard__body');

                if ($header.outerHeight() > headerMaxSize) {
                    headerMaxSize = $header.outerHeight();
                }

                if ($body.outerHeight() > bodyMaxSize) {
                    bodyMaxSize = $body.outerHeight();
                }
            });

            $cards.find('.ArticleCard__header').css({height: headerMaxSize + 'px'});
            $cards.find('.ArticleCard__body').css({height: bodyMaxSize + 'px'});
        }
    });
}


export function adaptSlider() {
    let height, fontSize, sliderWidth = $('.Section__banner').width();

    if ($(window).width() <= 640) {
        height = 350 * sliderWidth / 640;
        fontSize = 90 * sliderWidth / 640;
    } else {
        height = 540 * sliderWidth / 1920;
        fontSize = 100 * sliderWidth / 1920;
    }

    let items = 1,
        widthTest = $(window).width();
    if( widthTest >= sizes.mdMax && widthTest <= sizes.lgMax) {
        items = 3;
    } else if (widthTest >= sizes.lgMax) {
        items = 4;
    }

    if (isBeforeOrEqualDevice(devices.LG)) {

        $('.Projects__articles:not(.Projects__articles--no-slider)').addClass('owl-carousel').owlCarousel({
            items: items,
            margin: 15,
            autoHeight: true,
            dots: true,
            autoplay:true,
            autoplayTimeout:5000,
            autoplayHoverPause:true,
        })
    } else {
        $('.Projects__articles:not(.Projects__articles--no-slider)').each((i, el) => {
            let $el = $(el);
            if ($el.hasClass('owl-carousel')) {
                $el.removeClass('owl-carousel').trigger('destroy.owl.carousel');
            }
        })
    }

    // CARDS
    adaptCards();
    if (!isBeforeOrEqualDevice(devices.SM)) {
        $('.Projects__articles').each((i, el) => {
            let $cards = $(el).find('.ArticleCard');
            $cards.find('.ArticleCard__thumbnail').on('load', () => adaptCards());
        });
    }
}

